var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("booking-search-details-list", { attrs: { booking: _vm.booking } })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }